var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon9(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 29,
    r: 28.5,
    fill: "white",
    stroke: "#C4C4C4"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_723_16)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.5003 25V28.5H32.0003C32.0003 26.5662 30.4341 25 28.5003 25ZM28.5003 18V21.5C32.3608 21.5 35.5003 24.6395 35.5003 28.5H39.0003C39.0003 22.7005 34.2998 18 28.5003 18ZM28.5003 11V14.5C36.2196 14.5 42.5003 20.7807 42.5003 28.5H46.0003C46.0003 18.8347 38.1656 11 28.5003 11ZM36.6413 42.9093C36.6221 42.9635 36.6203 42.9723 36.6413 42.9093ZM35.705 38.2617C34.4888 37.6072 33.2585 36.8614 31.9863 36.3417C29.5275 35.3389 29.6938 38.3033 27.9386 39.264C26.7976 39.8888 25.1876 38.7566 24.1918 38.1301C22.4523 37.0346 20.9106 35.5929 19.6296 33.9252C18.9733 33.0729 17.5243 31.47 17.7028 30.2748C17.9863 28.3778 20.2298 28.2827 19.5875 25.9622C19.2445 24.7197 18.6303 23.4968 18.1701 22.2998C17.5541 20.6951 17.3003 19.6676 15.503 19.7551C14.2045 19.8181 13.3436 20.3733 12.5456 21.4146C10.3861 24.2268 10.7116 28.0184 12.1623 31.1036C14.2168 35.4699 17.7378 39.5862 21.4986 42.2462C24.0571 44.0557 27.4275 45.6987 30.525 45.9769C32.793 46.1817 35.9658 44.9554 36.7778 42.4932C36.7218 42.6647 36.6676 42.8305 36.6413 42.9093C36.6606 42.848 36.7026 42.7242 36.7778 42.4932C36.8601 42.2447 36.9003 42.1202 36.9195 42.0642C36.895 42.1377 36.8391 42.3095 36.7796 42.488C37.4936 40.318 37.581 39.2715 35.705 38.2617ZM36.9195 42.0642C36.9335 42.0222 36.9335 42.0187 36.9195 42.0642Z",
    fill: "#B1B1B1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_723_16"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    fill: "white",
    transform: "translate(11 11)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon9);
export default __webpack_public_path__ + "static/media/icon9.49d1e1128245fe4465898dbd21c65c66.svg";
export { ForwardRef as ReactComponent };